import React from "react";

const SkeletonGoalTable: React.FC = () => {
  return (
    <div className="border rounded-lg flex flex-col bg-white w-full max-h-[400px] min-h-[400px] overflow-hidden animate-pulse">
      {/* Header */}
      <div className="grid grid-cols-6 gap-4 px-4 py-4 font-semibold text-gray-700 border-b bg-white rounded-t-lg text-center">
        <div className="text-left">
          <div className="h-4 w-24 bg-gray-200 rounded"></div>
        </div>
        <div className="text-left">
          <div className="h-4 w-32 bg-gray-200 rounded"></div>
        </div>
        <div>
          <div className="h-4 w-20 bg-gray-200 rounded mx-auto"></div>
        </div>
        <div>
          <div className="h-4 w-20 bg-gray-200 rounded mx-auto"></div>
        </div>
        <div>
          <div className="h-4 w-28 bg-gray-200 rounded mx-auto"></div>
        </div>
        <div className="text-center">
          <div className="flex justify-end items-center">
            <div className="h-6 w-20 bg-gray-200 rounded-lg ml-auto"></div>
            <div className="ml-2 h-6 w-6  rounded-full"></div>
          </div>
        </div>
      </div>

      {/* Rows */}
      <div className="overflow-y-auto flex-1 text-center">
        {Array.from({ length: 3 }).map((_, idx) => (
          <div
            key={idx}
            className="grid grid-cols-6 gap-4 px-4 py-4 border-b text-gray-800"
          >
            <div className="text-left">
              <div className="h-4 w-24 bg-gray-200 rounded"></div>
            </div>
            <div className="text-left">
              <div className="h-4 w-32 bg-gray-200 rounded"></div>
            </div>
            <div>
              <div className="h-4 w-20 bg-gray-200 rounded mx-auto"></div>
            </div>
            <div>
              <div className="h-4 w-20 bg-gray-200 rounded mx-auto"></div>
            </div>
            <div>
              <div className="h-4 w-28 bg-gray-200 rounded mx-auto"></div>
            </div>
            <div className="flex justify-end items-center">
              <div className="h-6 w-20 bg-gray-200 rounded-lg"></div>
              <div className="ml-2 h-6 w-6 bg-gray-200 rounded-full"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonGoalTable;
